<div class="filter-for-list" *ngIf="!readOnly">

    <button type="button" class="btn top-list-tools" (click)="openModal()" placement="left"
            [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
        <fa-icon [icon]="faPlus"></fa-icon>
        {{'ADD_DEVICE'|translate}}
    </button>

    <div style="float:right">

        <mat-slide-toggle class="sliderActiveList" (change)="changeLockerValue()" ngModel="readMode"
                          placement="left"
                          [ngbTooltip]="'UNLOCK_SLIDER_TOOLTIP' | translate">
            <mat-icon style="color:gray;cursor:pointer" [innerHtml]="readMode ? 'lock' : 'lock_open'">
            </mat-icon>
        </mat-slide-toggle>

    </div>

    <br clear="both"/>

</div>
<div *ngIf="readOnly && projectDevices?.length" class="header">
    <b [innerHtml]="'DEVICES'|translate">Users</b>
    <app-button-project-edit [selectedStep]="4" *ngIf="readOnly"></app-button-project-edit>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>


<mat-expansion-panel *ngFor="let children of projectDevices;let i = index"
                     [ngClass]="i%2 ? 'row-pair' : 'row-unpair'" placement="top"
                     [ngbTooltip]="'CLICK_TO_EXPAND' | translate" (opened)="setOpened(i)"
                     [expanded]="readOnly ? true : isOpen(i)">
    <mat-expansion-panel-header>
        <app-progressbar *ngIf="showSpinner"></app-progressbar>
        <mat-panel-title>
            <mat-chip-list class="chip-expansion-title">
                <mat-chip>
                    {{children.device.device_type.type | translate}}
                </mat-chip>
            </mat-chip-list>
            <a class="linkInList">{{children.device.uid}} </a>
            <h4 class="expansion-title"> {{children.name}} </h4>
        </mat-panel-title>
        <mat-panel-description>
            <span *ngIf="children.dyndns">{{'DYNDNS'|translate}} : </span> <a *ngIf="children.dyndns"
                                                                              href="{{children.dyndns}}"
                                                                              target="_blank">{{children.dyndns}}</a>
        </mat-panel-description>

    </mat-expansion-panel-header>

    <div class="deviceAssignementInfosExpand" *ngIf="!readMode">
        <h4>{{'EDIT_DEVICE_INFO'|translate}}</h4>
        <mat-form-field>
            <input matInput [placeholder]="'NAME'|translate" [(ngModel)]="children.name" required type="text">
        </mat-form-field>
        &nbsp;
        <mat-form-field style="margin-left:10px;" *ngIf="children.device.device_type.id == 11">
            <input matInput placeholder="Dyn DNS" [(ngModel)]="children.dyndns" type="url">
        </mat-form-field>
        <mat-icon *ngIf="children.name?.length >3" style="color:green;cursor:pointer"
                  (click)="patchProjectDeviceAssignement(children.id,children.name,children.dyndns)"
                  matTooltipPosition="right"
                  [matTooltip]="'UPDATE_ICON_TOOLTIP'|translate">check_circle
        </mat-icon>

        <mat-icon *ngIf="children.name?.length <= 3" style="color:#cccccc;cursor:pointer"
                  (click)="patchProjectDeviceAssignement(children.id,children.name,children.dyndns)"
                  matTooltipPosition="right"
                  [matTooltip]="'UPDATE_ICON_TOOLTIP'|translate">check_circle
        </mat-icon>
    </div>
    <br *ngIf="!readMode" clear="both"/>

    <mat-chip-list>
        <mat-chip matBadgeColor="accent"
                  style="overflow: initial"
                  [removable]="true">
            {{children.device.device_type.type | translate}}
            <mat-icon matChipRemove *ngIf="!readMode" (click)="removeProjectDeviceAssignement(children.id) "
                      style="color:red"
                      matTooltipPosition="right" [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
            </mat-icon>
        </mat-chip>
    </mat-chip-list>

    <app-device-crud *ngIf="children.device.id" [deviceId]="children.device.id" [mode]="readOnly ? 'read' : 'update'"
                     [displayLink]="children.device.uid" [deviceType]="deviceTypes"
                     [unitList]="unitList"></app-device-crud>


    <button style="float:right" *ngIf="children.device.device_type.id == 11 && children.dyndns && !readOnly"
            type="button"
            class="btn list-tools"
            (click)="openScheduler(children.device.id)"
            placement="left"
            [ngbTooltip]="'OPEN_SCHEDULER_TOOLTIP' | translate">
        <fa-icon [icon]="faClock"></fa-icon>

    </button>
    <app-device-configuration-download style="float:right" [device]="children.device"
                                       *ngIf="!readOnly"></app-device-configuration-download>


    <div *ngFor="let children of children.device.children" class="box">
     <span class="location-infos" *ngIf="(children.device_type.id ===3  || children.device_type.id ===16) && children.location_name">{{children?.location_name}}</span>

      <span class="children-tiret"></span>
        <span class="dau-infos" *ngIf="children.params.screwTerminalBlock">
            <fa-icon [icon]="faProjectDiagram"></fa-icon>
            {{children.params.screwTerminalBlock}}
        </span>
        <mat-chip-list>
            <mat-chip matBadgeColor="accent" [matBadge]="children.channel" matBadgePosition="before"
                      style="overflow: initial"
                      [removable]="true" matTooltipPosition="above"
                      [matTooltip]="'Channel : ' + children.channel ">
                {{children.device_type.type | translate}}
              <span class="inner-badge" *ngIf="children.unit">{{children.unit.value|translate}}</span>
            </mat-chip>
        </mat-chip-list>
        <app-device-crud *ngIf="children.id" [deviceId]="children.id" [mode]="readOnly ? 'read' : 'update'"
                         [displayLink]="children.uid" [deviceType]="deviceTypes"
                         [unitList]="unitList"></app-device-crud>

        <br clear="left"/>


        <div class="children-box children-box-first">
            <div *ngFor="let children of children.children;let i = index"
                 [ngClass]="i===0?'dau-children-first':'dau-children'">
                <span class="location-infos"
                      *ngIf="children.device_type.id ===2  && children.location_name ">{{children?.location_name}}</span>
                <span *ngIf="children.device_type.id ===2" class="children-tiret"></span>
                <mat-chip-list *ngIf="children.device_type.id ===2">
                    <mat-chip matBadgeColor="accent" [matBadge]="children.channel" matBadgePosition="before"
                              style="overflow: initial"
                              [removable]="true" matTooltipPosition="above"
                              [matTooltip]="'Channel : ' + children.channel ">
                        {{children.device_type.type | translate}}
                        <span class="inner-badge-length" *ngIf="children?.length">{{children.length}}m</span>
                    </mat-chip>
                </mat-chip-list>


                <app-device-crud *ngIf="children.device_type.id ===2" [deviceId]="children.id"
                                 [mode]="readOnly ? 'read' : 'update'"
                                 [displayLink]="children.uid" [deviceType]="deviceTypes"
                                 [unitList]="unitList"></app-device-crud>

            </div>
        </div>

        <div class="children-box">
            <div *ngFor="let children of children.children;let i = index"
                 [ngClass]="i===0?'dau-children-first':'dau-children'">
                <span class="location-infos"
                      *ngIf="children.device_type.id ===3  && children.location_name ">{{children?.location_name}}</span>
                <span *ngIf="children.device_type.id ===3" class="children-tiret"></span>
                <mat-chip-list *ngIf="children.device_type.id ===3">
                    <mat-chip matBadgeColor="accent" [matBadge]="children.channel" matBadgePosition="before"
                              style="overflow: initial"
                              [removable]="true" matTooltipPosition="above"
                              [matTooltip]="'Channel : ' + children.channel ">
                        {{children.device_type.type | translate}}
                        <span class="inner-badge" *ngIf="children.unit">{{children.unit.value|translate}}</span>
                    </mat-chip>
                </mat-chip-list>


                <app-device-crud *ngIf="children.device_type.id ===3" [deviceId]="children.id"
                                 [mode]="readOnly ? 'read' : 'update'"
                                 [displayLink]="children.uid" [deviceType]="deviceTypes"
                                 [unitList]="unitList"></app-device-crud>

            </div>
        </div>


        <div class="children-box">
            <div *ngFor="let children of children.children;let i = index"
                 [ngClass]="i===0?'dau-children-last':'dau-children'">
                <span class="location-infos"
                      *ngIf="children.device_type.id ===4 && children.location_name">{{children?.location_name}}</span>
                <span *ngIf="children.device_type.id ===4" class="children-tiret"></span>
                <mat-chip-list *ngIf="children.device_type.id ===4">
                    <mat-chip matBadgeColor="accent" [matBadge]="children.channel" matBadgePosition="before"
                              style="overflow: initial"
                              [removable]="true" matTooltipPosition="above"
                              [matTooltip]="'Channel : ' + children.channel ">
                        {{children.device_type.type | translate}}
                    </mat-chip>
                </mat-chip-list>


                <app-device-crud *ngIf="children.device_type.id ===4" [deviceId]="children.id"
                                 [mode]="readOnly ? 'read' : 'update'"
                                 [displayLink]="children.uid" [deviceType]="deviceTypes"
                                 [unitList]="unitList"></app-device-crud>

            </div>
        </div>


    </div>
    <br clear="left"/>
</mat-expansion-panel>
<br/>
